import { _breakP } from './utils.js';
export default class pageScroll {
  constructor() {
    this.pageScroll();
  }

  pageScroll() {
    const $pageScroll = document.querySelectorAll('.js-pageScroll');
    if (!$pageScroll.length) return;
    $pageScroll.forEach(elm => {
      elm.addEventListener('click', e => {
        e.preventDefault();
        const header = _breakP.SP ? document.getElementById('spMenu') : document.getElementById('gHeader');
        const headerHeight = header.offsetHeight;
        const targetId = elm.getAttribute('href');
        if (!targetId) return;
        const target = document.querySelector(targetId);
        if (!target) return;
        if (window.__lenis && !window.__lenis.isStopped) {
          window.__lenis.scrollTo(target, { offset: -headerHeight });
        } else {
          const rectTop = target.getBoundingClientRect().top;
          const positionY = window.pageYOffset;
          const targetPosition = rectTop + positionY - headerHeight;
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }
}
